var $a673c623b11eebb3$exports = {};
$a673c623b11eebb3$exports = {
    "valid": `Valabil`
};


export {$a673c623b11eebb3$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
